import React from 'react';
import classNames from 'classnames';
import ResponsiveThumbnail from 'common/ResponsiveThumbnail';
import connectPlayer from 'player/connectPlayer';
import ContentMetadataLarge from './ContentMetadataLarge';

// this needs to be a class because we're connecting a player to it
class Hero extends React.Component {
    render() {
        const { content } = this.props;
        const playButtonClasses = classNames('button-play', 'button-play--video', {
            'button-play--live': (content.status === 'live')
        });

        const hero = content ? (
            <article className="hero--super" data-score={content.score}>
                <figure className="hero_wrapper">
                    <a className="col-a">
                        <div onClick={this.props.clickHandler} id={`hero-${content.id}`} ref="playerElement">
                            <ResponsiveThumbnail className="hero_img" src={content.imageHref} sizes="100vw" alt={content.name} />
                            <div className={playButtonClasses} />
                            <ContentMetadataLarge
                                isHero
                                userAuthenticatedForContent={this.props.userAuthenticatedForContent}
                                contentType={content.type}
                                status={content.status}
                                duration={content.duration}
                                name={content.name}
                                subtitle={content.formattedSubtitle}
                                time={content.time}
                            />
                        </div>
                    </a>
                </figure>
            </article>
        ) : null;

        return <div>{hero}</div>;
    }
}

Hero.defaultProps = {
    clickHandler: (event) => {
        event.preventDefault();
    }
};

Hero.propTypes = {
    clickHandler: React.PropTypes.func,
    content: React.PropTypes.object,
    userAuthenticatedForContent: React.PropTypes.bool
};

export default connectPlayer(Hero);



// WEBPACK FOOTER //
// ./app/page/hero/Hero.js